import React from "react";
import { steps } from "./landingContent";

export default function LandingSteps() {
  return (
    <section className="hr-landing-section" aria-labelledby="hr-landing-steps-title">
      <div className="home-page__container">
        <header className="hr-landing-section__head">
          <h2 id="hr-landing-steps-title" className="hr-landing-section__title">
            איך מתחילים
          </h2>
        </header>
        <ol className="hr-landing-steps">
          {steps.map((s) => (
            <li key={s.step} className="hr-landing-step">
              <span className="hr-landing-step__num">{s.step}</span>
              <div>
                <h3 className="hr-landing-step__title">{s.title}</h3>
                <p className="hr-landing-step__text">{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
